import React from 'react';

export default function UpvoteButton({ bar, userId, onToggle, onRequireLogin }) {
  const disabled = !userId;

  const handleClick = () => {
    if (!userId) {
      if (onRequireLogin) {
        onRequireLogin(() => {
          // Re-trigger upvote after login
          if (onToggle) onToggle();
        });
      }
      return;
    }
    if (onToggle) onToggle();
  };

  return (
    <button
      type="button"
      className={`upvote-btn ${bar.hasUpvoted ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      disabled={disabled && !onRequireLogin}
      title={disabled ? 'Faça login para votar' : bar.hasUpvoted ? 'Remover voto' : 'Votar'}
    >
      <span className="upvote-arrow">⬆</span>
      <span>{bar.upvoteCount || 0}</span>
    </button>
  );
}
